

















import {Component, Emit, Prop, Ref, Vue, Watch} from 'vue-property-decorator';
import AdminNavBar from './AdminNavBar.vue';
import {MAFUser} from '@/store/User/types';
import {Action, Mutation, Getter, namespace, State} from 'vuex-class';
import luxon from '@/plugins/luxon';
import * as _ from 'lodash';
import {MAFViolation} from '@/store/Violations/types';
import {User} from 'firebase'; // @ is an alias to /src
import * as firebase from 'firebase/app';
import DocumentReference = firebase.firestore.DocumentReference;
import {DateTime} from 'luxon';

const violationsPath = 'violationState';
const violationsNamespace = namespace(violationsPath);

const userPath = 'userState';
const userNamespace = namespace(userPath);

@Component({
    components: {},
})
export default class InteractionModal extends Vue {
    @Prop() public readonly reportedUser!: MAFUser | undefined;
    @Prop() public readonly violation!: MAFViolation | undefined;
    @violationsNamespace.State('violations') public Violations !: MAFViolation[];
    @violationsNamespace.Action('getMAFViolations') public getMAFViolations: any;
    public created() {
        this.getMAFViolations();
    }
    public data() {
        return{
        };
    }
    public age(date: any) {
        // this is on the user model but for some reason it says get type not a function error?
        const now = DateTime.local();
        let birthday: DateTime | null = null;
        if (!date) {
            return 'No Age Set';
        }
        if (typeof date === 'string') {
            birthday = DateTime.fromISO(date);
        } else if (date instanceof Date) {
            birthday = DateTime.fromJSDate(date);
        } else {
            birthday = DateTime.local();
        }
        const diffInYears = now.diff(birthday, 'years').toObject().years;
        return `${diffInYears ? diffInYears.toFixed(0) : 0} Years Old`;
    }
}
